import type { ComponentTemplateTransform } from "./src/types";

import { isComponentInsideProductComponent } from "replo-runtime/shared/Component";

export const transformReviewsTemplateToUseProductForContextIfNecessary: ComponentTemplateTransform =
  (component, parent, element, extras) => {
    if (!parent) {
      return component;
    }

    const { componentDataMapping } = extras;

    // NOTE (Fran 2024-05-21): If the component is inside a product context, we want to use the product
    // from the context instead of the one from the component.
    if (isComponentInsideProductComponent(component.id, componentDataMapping)) {
      component.props["_product"] = {
        type: "contextRef",
        ref: "attributes._product",
      };
    }

    if (element?.type === "shopifyProductTemplate") {
      component.props["_templateProduct"] = {
        type: "contextRef",
        ref: "attributes._templateProduct",
      };
    }

    return component;
  };
